import {
  ChangeEventHandler,
  KeyboardEventHandler,
  forwardRef,
  InputHTMLAttributes,
} from "react";
import styles from "./GstInput.module.scss";

interface GstInputProps {
  label?: string;
  value: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
  placeholder?: string;
  type?: string;
  maxLength?: number;
  disabled?: boolean;
  id?: string;
  // OTP variant — renders a single bare box (no label); parent owns focus/paste logic
  isOtpInput?: boolean;
  hasError?: boolean;
  inputMode?: InputHTMLAttributes<HTMLInputElement>["inputMode"];
}

const GstInput = forwardRef<HTMLInputElement, GstInputProps>(function GstInput(
  {
    label,
    value,
    onChange,
    onKeyDown,
    placeholder,
    type = "text",
    maxLength,
    disabled = false,
    id,
    isOtpInput = false,
    hasError = false,
    inputMode,
  },
  ref
) {
  if (isOtpInput) {
    return (
      <input
        ref={ref}
        className={`${styles.otpBox} ${hasError ? styles.otpBoxError : ""}`}
        type={type}
        inputMode={inputMode}
        maxLength={maxLength}
        value={value}
        disabled={disabled}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />
    );
  }

  return (
    <div className={styles.field}>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      <input
        ref={ref}
        id={id}
        className={`${styles.input} ${hasError ? styles.inputError : ""}`}
        type={type}
        value={value}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />
    </div>
  );
});

export default GstInput;